
import Q2TablePoker from "./q2_table_poker";

const { ccclass, property, menu } = cc._decorator;

const const_color_config = {
    [1]: 'color_black_heart',
    [2]: 'color_red_heart',
    [3]: 'color_plum',
    [4]: 'color_square',
}

@ccclass
export default class Q2TablePokerSmall extends Q2TablePoker{

    protected getColorSpriteFrame(color: number, point: number){
        let key = `${const_color_config[color]}_mid`
        return this.getSpriteFrameByName(key)
    }

    protected getBigColorSpriteFrame(color: number, point: number){
        return null
    }
    
}
